module.exports = __webpack_public_path__ + "img/image15.c4d979bd.png";